/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteCandidateChoiceKindEnum =
  (typeof RouteCandidateChoiceKindEnum)[keyof typeof RouteCandidateChoiceKindEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteCandidateChoiceKindEnum = {
  OnlyCandidate: 0,
  Closest: 1,
  CloserNeededElsewhere: 2,
  GlobalAssignment: 3,
  FullTimeFirst: 4,
  CloserIsEmergencyOnly: 5,
  ScheduleDelay: 6,
  CloserFreedLater: 7,
} as const;
